<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="3" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Coin Seller / Merchant'
                    : 'Deleted Coin Seller / Merchant'
                "
              ></h3>
              <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/coinseller-merchants/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="4">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="type"
                    solo
                    rounded
                    v-model="filter.type"
                    :items="typeFilters"
                    clearable
                    @click:clear="(filter.type = null), (page = 1), getData()"
                    label="Filter by Type"
                    @input="getData"
                    prepend-inner-icon="mdi-filter"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="3" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                :height="$vuetify.breakpoint.mobile ? '60vh' : '70vh'"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-start sr_no">Sr No</th>
                      <th class="text-start">Status</th>
                      <th class="text-start">Type</th>
                      <th class="text-start">User ID</th>
                      <th class="text-start">User Name</th>
                      <th class="text-start">WhatsApp No</th>
                      <th class="text-start">Balance</th>
                      <th class="text-start">Created By</th>
                      <th class="text-start">Created At</th>
                      <th class="text-start action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="userPositions.length != 0">
                    <tr
                      v-for="(position, i) in userPositions"
                      :key="`position_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': userPositions.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip
                          bottom
                          v-if="
                            (position.is_coin_seller == 1 &&
                              position.is_merchant == 0) ||
                            (position.is_coin_seller == 0 &&
                              position.is_merchant == 1)
                          "
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>User is Active</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="
                            position.is_coin_seller == 0 &&
                            position.is_merchant == 0
                          "
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>User is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-chip
                          small
                          :color="
                            position.is_coin_seller == 1 ? 'purple' : 'orange'
                          "
                          text-color="white"
                        >
                          <v-avatar left>
                            <v-icon size="15">{{
                              position.is_coin_seller == 1
                                ? "mdi-wallet"
                                : "mdi-store"
                            }}</v-icon>
                          </v-avatar>
                          {{
                            position.is_coin_seller == 1
                              ? "Coin Seller"
                              : position.is_merchant == 1
                              ? "Merchant"
                              : "N/A"
                          }}
                        </v-chip>
                      </td>
                      <td>
                        {{ position.unique_id || "" }}
                      </td>
                      <td>
                        <v-chip small color="blue" text-color="white">
                          <v-avatar left>
                            <v-icon size="15">mdi-account</v-icon>
                          </v-avatar>
                          {{
                            position.first_name + " " + position.last_name ||
                            "N/A"
                          }}
                        </v-chip>
                      </td>
                      <td>
                        {{ position.whatsapp_no || "N/A" }}
                      </td>
                      <td>
                        <v-chip small color="green" text-color="white">
                          <v-avatar left>
                            <v-icon size="15">mdi-currency-usd</v-icon>
                          </v-avatar>
                          {{ position.wallet_balance || 0 }}
                        </v-chip>
                      </td>
                      <td>
                        {{
                          position.admin_creator
                            ? position.admin_creator.first_name +
                              " " +
                              position.admin_creator.last_name
                            : "N/A"
                        }}
                      </td>
                      <td>
                        {{ formatDate(position.created_at) }}
                      </td>
                      <td class="text-left">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="primary"
                                :to="`/coinseller-merchants/${encryptIt(
                                  position.id
                                )}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this User</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto ml-2"
                                color="error"
                                @click="Delete_this(position.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this User</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(position.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this User</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="10" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Delete Success Dialog Box -->
      <v-dialog v-model="is_deleted_position" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>User deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_position = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_position" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>User restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_position = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "CoinSellerMerchantIndexPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        user_id: null,
        is_coin_seller_or_merchant: 1,
        type: null,
      },
      userPositions: [],
      users: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      typeFilters: [
        { text: "All", value: "" },
        { text: "Coin Seller", value: "coin_seller" },
        { text: "Merchant", value: "merchant" },
      ],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      delete_position: false,
      is_deleted_position: false,
      is_restored_position: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    // this.getUsers();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      this.filter.is_coin_seller_or_merchant = 1;

      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&user_id=" +
        this.filter.user_id +
        "&is_coin_seller_or_merchant=" +
        this.filter.is_coin_seller_or_merchant +
        "&search_keyword=" +
        this.filter.search_keyword;

      // Add type filter
      if (this.filter.type === "coin_seller") {
        query += "&is_coin_seller=1";
      } else if (this.filter.type === "merchant") {
        query += "&is_merchant=1";
      }

      await axios
        .get(`users?${query}`)
        .then((response) => {
          this.userPositions = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },
    async getUsers() {
      await axios
        .get(`users`)
        .then((response) => {
          this.users = response.data.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`user_position_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_position = true;
      await axios
        .post(`/user/update-flag/delete?id=${id}`)
        .then(() => {
          this.delete_position = false;
          this.is_deleted_position = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async Restore_this(id) {
      this.restore_position = true;
      await axios
        .post(`/user_positions/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_position = false;
          this.is_restored_position = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getRoleColor(role) {
      const roleColors = {
        admin: "red",
        manager: "orange",
        supervisor: "blue",
        team_lead: "purple",
        member: "green",
        viewer: "grey",
      };
      return roleColors[role?.toLowerCase()] || "indigo";
    },
    formatDate(date) {
      if (!date) return "N/A";
      return new Date(date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
  },
};
</script>
